<template>
    <app-layout title="Refund">
        <form @submit.prevent="handleSubmit">
            <page-header>
                <template #title>Credit Request</template>

                <template #actions>
                    <jet-tertiary-button
                        :href="`/refunds/${refund.id}`"
                    >
                        Cancel
                    </jet-tertiary-button>
                </template>
            </page-header>

            <div class="flex flex-col px-3 md:px-4 lg:px-8 gap-y-4">
                <refund-details
                    :form="form"
                    :order="order"
                    :isCreate="!isCompletedEditMode"
                    :refund="refund"
                />

                <refunds-products-edit
                    v-if="isCompletedEditMode"
                    :form="form"
                    :ordered_products="order_products"
                    :returnReasons="returnReasons"
                />
                <refund-products
                    v-else
                    :form="form"
                    :ordered_products="order_products"
                    :noImageReturnReasons="noImageReturnReasons"
                    :returnReasons="returnReasons"
                    :refund="refund"
                />
            </div>

            <div class="text-center py-24">
                <div class="flex justify-center gap-x-8">
                    <jet-button type="submit" class="leading-none" style="padding-left: 2rem; padding-right: 2rem; padding-top: 1rem; padding-bottom: 1rem; font-size: 1rem;">
                        {{ isCompletedEditMode ? 'Update' : 'Submit' }}
                    </jet-button>
                </div>
            </div>
        </form>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import RefundDetails from '@/Pages/Refund/Partials/RefundDetails.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import RefundProducts from '@/Pages/Refund/Partials/RefundProducts.vue';
import RefundsProductsEdit from '@/Pages/Refund/Partials/RefundsProductsEdit.vue';

export default {
    setup(props) {
        const isCompletedEdit = !!(props.isCompletedEdit ?? props.is_completed_edit);
        const form = useForm(
            isCompletedEdit
                ? { id: props.refund.id, itemReason: {}, returnNote: {} }
                : {
                    existingOrderItems: {},
                    itemsToReturn: {},
                    itemReason: {},
                    qtyToAdd: {},
                    itemImages: {},
                    returnNote: {},
                    receiptImage: null,
                    id: props.refund.id,
                }
        );

        const refundItems = props.refund.refund_order_items || props.refund.refundOrderItems || [];
        if (isCompletedEdit) {
            for (const refundOrderItem of refundItems) {
                form.itemReason[refundOrderItem.id] = refundOrderItem.return_reason;
                form.returnNote[refundOrderItem.id] = refundOrderItem.return_note ?? '';
            }
        } else {
            for (const refundOrderItem of refundItems) {
                form.existingOrderItems[refundOrderItem.order_item.id] = refundOrderItem.id;
                form.itemsToReturn[refundOrderItem.order_item.id] = true;
                form.itemReason[refundOrderItem.order_item.id] = refundOrderItem.return_reason;
                form.qtyToAdd[refundOrderItem.order_item.id] = refundOrderItem.quantity;
                form.returnNote[refundOrderItem.order_item.id] = refundOrderItem.return_note;
            }
        }

        return { form };
    },

    props: {
        order: Object,
        order_products: Array,
        noImageReturnReasons: Array,
        returnReasons: Array,
        refund: Object,
        isCompletedEdit: { type: Boolean, default: false },
        is_completed_edit: { type: Boolean, default: false },
    },

    computed: {
        isCompletedEditMode() {
            return !!(this.isCompletedEdit || this.is_completed_edit);
        },
    },

    components: {
        AppLayout,
        PageHeader,
        RefundDetails,
        JetButton,
        JetTertiaryButton,
        RefundProducts,
        RefundsProductsEdit,
    },

    data() {
        return {
            formRoute: this.route('refunds.store'),
        }
    },

    methods: {
        handleSubmit() {
            if (this.form.processing) return;
            if (this.isCompletedEditMode) {
                this.form.put(route('refunds.update', this.refund.id));
            } else {
                this.form
                    .transform((data) => ({
                        ...data,
                        token: this.order.refund_token,
                    }))
                    .post(route('refunds.store'));
            }
        },
        
        closeWindow() {
            window.close();
        },
    },
}
</script>

<style scoped>
.multi-custom {
    min-height: 1.5rem;
}
</style>
